var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-modal",
    {
      ref: "modalEdicion",
      attrs: { size: "s", title: "Cargar CAF" },
      on: { close: _vm.cerrarModal }
    },
    [
      _c(
        "div",
        { staticClass: "p-4", attrs: { slot: "header" }, slot: "header" },
        [_c("h4", [_vm._v("Cargar CAF")])]
      ),
      _vm.show
        ? _c("div", { staticClass: "vx-row" }, [
            _c("div", { staticClass: "vx-col w-full" }, [
              _c("div", { staticClass: "dropbox" }, [
                _c("input", {
                  staticClass: "input-file",
                  attrs: {
                    type: "file",
                    name: _vm.fileCAF,
                    accept: "text/xml"
                  },
                  on: { change: _vm.caf_onChange }
                }),
                _vm.precarga
                  ? _c("p", [_vm._v(" Arrastre su CAF hasta aquí ")])
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm.show
        ? _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col md:w-1/2 mt-3" },
              [
                _c("vs-input", {
                  staticClass: "w-full",
                  attrs: {
                    label: "Folio inicial",
                    maxlength: "10",
                    name: "inicial",
                    type: "number",
                    readonly: "readonly"
                  },
                  model: {
                    value: _vm.caf.inicial,
                    callback: function($$v) {
                      _vm.$set(_vm.caf, "inicial", $$v)
                    },
                    expression: "caf.inicial"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col md:w-1/2 mt-3" },
              [
                _c("vs-input", {
                  staticClass: "w-full",
                  attrs: {
                    label: "Folio final",
                    maxlength: "10",
                    name: "final",
                    type: "number",
                    readonly: "readonly"
                  },
                  model: {
                    value: _vm.caf.final,
                    callback: function($$v) {
                      _vm.$set(_vm.caf, "final", $$v)
                    },
                    expression: "caf.final"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.show
        ? _c(
            "div",
            {
              staticClass: "vs-row mt-5",
              staticStyle: { "text-align": "right" }
            },
            [
              _c(
                "vs-button",
                {
                  attrs: {
                    color: "primary",
                    type: "filled",
                    disabled: _vm.disabledCargar
                  },
                  on: { click: _vm.enviarCAF }
                },
                [_vm._v("Cargar")]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }